routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.documentsList', {
      url: "/consultas/documentos",
      template: `<documents-list sh-ctrl="shCtrl"></documents-list>`,
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/documents-list/documents-list.config.js
 **/